import React from 'react';
import { Pencil, Trash2 } from 'lucide-react';
import classes from '../templates.module.scss';
import { createCn } from '../../../helpers/utils';
import { ProtocolTemplate } from '../../../services/templates.service';

const cn = createCn('templates', classes);

function sectionsWord(count: number): string {
  const mod10 = count % 10;
  const mod100 = count % 100;
  if (mod10 === 1 && mod100 !== 11) return 'секция';
  if ([2, 3, 4].includes(mod10) && ![12, 13, 14].includes(mod100)) return 'секции';
  return 'секций';
}

interface TemplateCardProps {
  template: ProtocolTemplate;
  onEdit: () => void;
  onDelete: () => void;
  deleting?: boolean;
}

const TemplateCard = ({ template, onEdit, onDelete, deleting }: TemplateCardProps) => {
  return (
    <div className={cn('card')}>
      <div className={cn('card-header')}>
        <div className={cn('card-title')}>{template.name}</div>
        {template.is_default && <span className={cn('badge')}>По умолчанию</span>}
      </div>

      {template.description && <div className={cn('card-desc')}>{template.description}</div>}

      <div className={cn('card-meta')}>
        {template.sections.length} {sectionsWord(template.sections.length)}
      </div>

      <div className={cn('card-actions')}>
        <button type="button" className={cn('icon-btn')} onClick={onEdit} aria-label="Редактировать шаблон">
          <Pencil size={16} /> Редактировать
        </button>
        <button
          type="button"
          className={cn('icon-btn', { danger: true })}
          onClick={onDelete}
          disabled={template.is_default || deleting}
          title={template.is_default ? 'Нельзя удалить дефолтный шаблон' : 'Удалить шаблон'}
          aria-label="Удалить шаблон"
        >
          <Trash2 size={16} /> {deleting ? 'Удаление…' : 'Удалить'}
        </button>
      </div>
    </div>
  );
};

export default TemplateCard;
